var checkProgress = function (global) {
    var answered = global.currentSlide + 1;

    var total = global.flashcards.length;


    var percentage = Math.floor(answered/total * 100);

    var progressBar = $(global.flashcard).find('.progress .progress-bar');
    $(progressBar).attr('aria-valuenow',percentage);
    $(progressBar).css('width',percentage + '%');
    $(progressBar).html(percentage + '%');

    $(global.flashcards).find('.count').html( answered + '/' + total);

    if (global.currentSlide > 0 ) {
        enablePrevious();
    } else {
        disablePrevious();
    }
    if (global.currentSlide < global.flashcards.length -1 ) {
        enableNext();
    } else {
        disableNext();
    }
}
module.exports = checkProgress;


//////////////////
// WEBPACK FOOTER
// ./src/flashcard_checkprogress.js
// module id = 307
// module chunks = 0